export enum InferenceLocations {
  SERVER = 0,
  CLIENT = 1,
}
